import * as React from 'react'

import * as styles from './iPhone.module.scss'

export const IPhone: React.FC = ({ children }) => {
  return <div className={`${styles.iPhone} phone`}>{children}</div>
}
